"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var formik_1 = require("formik");
var react_redux_1 = require("react-redux");
var contactUsFormSchema_1 = __importDefault(require("../../../schemas/contactUsFormSchema"));
var contactUsSlice_1 = require("../../../features/contactUs/contactUsSlice");
var globalSlice_1 = require("../../../features/global/globalSlice");
var Button_1 = __importDefault(require("../../../components/Button"));
var Validation_1 = __importDefault(require("../../../components/Validation"));
var BlTextArea_1 = __importDefault(require("../../../components/FormComponents/BlTextArea"));
var BlInput_1 = __importDefault(require("../../../components/FormComponents/BlInput"));
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ContactFrom = function () {
    var t = react_i18next_1.useTranslation('common').t;
    var dispatch = react_redux_1.useDispatch();
    var contactUsLoading = react_redux_1.useSelector(contactUsSlice_1.getFetchingToContactUsLoading);
    var handleSendMessage = function (values, resetForm) { return __awaiter(void 0, void 0, void 0, function () {
        var e_1, key;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, dispatch(contactUsSlice_1.contactUs(values))];
                case 1:
                    _a.sent();
                    dispatch(globalSlice_1.addToastMessage({
                        text: t('FOOTER.NEWSLETTER_SUCCESS'),
                        appearance: 'success',
                    }));
                    resetForm();
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    key = Object.keys(e_1.response.data.errors)[0];
                    if (e_1.response.status === 422) {
                        dispatch(globalSlice_1.addToastMessage({
                            text: t('ERRORS.' + e_1.response.data.errors[key][0]),
                            appearance: 'error',
                        }));
                    }
                    else {
                        dispatch(globalSlice_1.addToastMessage({
                            text: t('FOOTER.NEWSLETTER_ERROR'),
                            appearance: 'error',
                        }));
                    }
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getErrorClass = function (formik, fieldName) {
        return formik.touched[fieldName] && formik.errors[fieldName]
            ? 'has-errors'
            : '';
    };
    return (react_1.default.createElement(formik_1.Formik, { initialValues: {
            name: '',
            email: '',
            subject: '',
        }, validationSchema: contactUsFormSchema_1.default, onSubmit: function (values, _a) {
            var resetForm = _a.resetForm;
            handleSendMessage(values, resetForm);
        } }, function (formik) { return (react_1.default.createElement("div", { className: styles_module_scss_1.default.contact_us_wrap },
        react_1.default.createElement(formik_1.Form, { className: "flex-column", action: "" },
            react_1.default.createElement(Validation_1.default, { name: "name", formikProps: formik },
                react_1.default.createElement(BlInput_1.default, __assign({ className: classnames_1.default(styles_module_scss_1.default.input, getErrorClass(formik, 'name')), type: "text", placeholder: t('CONTACT_FROM.NAME') }, formik.getFieldProps('name')))),
            react_1.default.createElement(Validation_1.default, { name: "email", formikProps: formik },
                react_1.default.createElement(BlInput_1.default, __assign({ className: classnames_1.default(styles_module_scss_1.default.input, getErrorClass(formik, 'email')), type: "email", placeholder: t('CONTACT_FROM.EMAIL') }, formik.getFieldProps('email')))),
            react_1.default.createElement(Validation_1.default, { name: "subject", formikProps: formik },
                react_1.default.createElement(BlTextArea_1.default, __assign({ className: classnames_1.default(styles_module_scss_1.default.textarea, getErrorClass(formik, 'subject')), rows: 4, cols: 40, placeholder: t('CONTACT_FROM.TEXTAREA') }, formik.getFieldProps('subject')))),
            react_1.default.createElement(Button_1.default, { className: styles_module_scss_1.default.button, type: "submit", disabled: contactUsLoading, loading: contactUsLoading }, t('CONTACT_FROM.BTN'))))); }));
};
exports.default = ContactFrom;
